"use client";

import { RecommendType } from "@/lib/types/generic";

type RecommendRecordUserViewProps = {
  itemType: RecommendType;
  itemId: string;
  recommId?: string;
};

export default function RecommendRecordUserView(_props: RecommendRecordUserViewProps) {
  return null;
}
